export const APP_MODE = "prod";
export const APP_SERVER_URL = "https://api.winpot.mx/";
export const APP_WINPOT_CASINO = "https://www.winpot.mx/";